import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  setLayoutToActivePage,
  removeplaceholdersFromPage,
  removeDroppedImages } from '../../redux/actions/entities/pages';
import { updateCoverSizes } from '../../redux/actions/bookproperties';

import './Layout.css';
import {
  calculateRatio,
  GetActivePage,
  isImageInChange,
  MmToPx,
} from '../../redux/helpers/index';


class Layout extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      originalLayoutBoxHeight: 0,
    };
    this.originalLayoutBoxHeight = 0;
    this.startRendering = this.startRendering.bind(this);
    this.stopRendering = this.stopRendering.bind(this);
    this.state = {
      isRendering: false,
    };
  }

  componentDidMount() {
    this.setLayoutBoxHeight();
  }

  setLayoutBoxHeight = () => {
    const { layoutHeight } = this.props.bookProperties;
    this.setState({
      originalLayoutBoxHeight: layoutHeight,
    });
  }


  setLayout = () => {
    this.startRendering();
    this.setDebounce();
    if (!this.state.isRendering) {
      const {
        id,
        isChange,
        isFrontFlyleaf,
        isBackFlyleaf,
        isBabyPlaceholder,
        pages,
        lang,
        layouts,
      } = this.props;
      const getActivePage = GetActivePage(pages);
      const activePageId = getActivePage.id;
      const activePageLayout = getActivePage.layout;

      // If flyleaf
      if (isFrontFlyleaf || isBackFlyleaf || isBabyPlaceholder) {
        if (id !== activePageLayout) {
          const blank = layouts[id].placeholders[0];
          // If empty flyleaf
          if (blank.left === 0 && blank.top === 0 && blank.width === 0 && blank.height === 0) {
            this.props.dispatch(removeplaceholdersFromPage(activePageId));
            this.props.dispatch(removeDroppedImages(activePageId));
          }
          return this.props.dispatch(setLayoutToActivePage(id, activePageId));
        }
      }

      if (isChange) {
        isImageInChange(isChange, getActivePage.isCover, lang);
        return false;
      }

      // if is Cover
      if (getActivePage.isCover) {
        const selectedCover = layouts[id];

        const {
          width,
          height,
        } = selectedCover;
        this.props.dispatch(updateCoverSizes(
          width,
          height,
          MmToPx(width),
          MmToPx(height),
        ));
      }

      if (id !== activePageLayout) {
        this.props.dispatch(setLayoutToActivePage(id, activePageId, false, false));
      }
    }
    return true;
  }

  setDebounce() {
    this.setTimeout = clearTimeout(this.setTimeout);
    this.setTimeout = setTimeout(this.stopRendering, 1500);
  }

  startRendering() {
    this.setState({ isRendering: true });
  }

  stopRendering() {
    this.setState({ isRendering: false });
  }

  renderPlaceholders() {
    const {
      placeholders,
      height,
      isCover,
      pages,
      layouts,
      isFrontFlyleaf,
      isBackFlyleaf,
    } = this.props;


    const activePage = Object.values(pages).find(element => element.isActive);
    const activeLayout = layouts[activePage.layout];

    if (!activeLayout) {
      return;
    }

    const calculatedPlaceholders = placeholders ?
      placeholders.map((key, index) => {
        if (key.width === 0 && key.height === 0 && (isFrontFlyleaf || isBackFlyleaf)) {
          return <p key={index} className="blankflyleaf">Blank</p>;
        }

        if (key.width === 0 && key.height === 0 && isCover) {
          return '';
        }

        const ratio = isCover ? height / this.props.layouts[this.props.id].height : height / this.state.originalLayoutBoxHeight;
        const placeholderStyles = calculateRatio(ratio, key,0, false);
        return <div key={index} style={placeholderStyles} />;
      }) : '';

    return calculatedPlaceholders;
  }

  render() {
    const {
      height,
      width,
      isCover,
      isBabyPlaceholder,
      isBlank,
    } = this.props;

    const style = {
      height,
      width,
    };

    const hideEmptyBabyPlaceholder = isBabyPlaceholder && isBlank;

    if ((hideEmptyBabyPlaceholder) || (isCover && this.renderPlaceholders() && this.renderPlaceholders()[0] === '')) {
      return false;
    }

    return (
      <div className="Layout" style={style} role="presentation" onClick={event => this.setLayout(event)}>
        { this.renderPlaceholders() }
      </div>
    );
  }
}

Layout.defaultProps = {
  placeholders: [],
  height: 0,
  isCover: false,
  width: 0,
  id: 0,
  isChange: false,
  isFrontFlyleaf: false,
  isBackFlyleaf: false,
  pages: {},
  bookProperties: {},
  lang: {},
  layouts: {},
  dispatch: () => {},
  isBabyPlaceholder: false,
};

Layout.propTypes = {
  placeholders: PropTypes.array,
  height: PropTypes.number,
  isCover: PropTypes.bool,
  width: PropTypes.number,
  id: PropTypes.number,
  isChange: PropTypes.bool,
  isFrontFlyleaf: PropTypes.bool,
  isBackFlyleaf: PropTypes.bool,
  pages: PropTypes.object,
  bookProperties: PropTypes.object,
  lang: PropTypes.object,
  layouts: PropTypes.object,
  dispatch: PropTypes.func,
  isBabyPlaceholder: PropTypes.bool,
};


export default connect(state => ({
  isChange: state.editorUI.imageChange.isChange,
  bookProperties: state.bookProperties.dimensions,
  bookId: state.bookProperties,
  layouts: state.entities.layouts.byId,
}
))(Layout);



// WEBPACK FOOTER //
// ./src/components/layout/Layout.jsx